<template>
  <div class="md:grid md:grid-cols-5 md:overflow-auto md:h-screen">
    <div
      class="col-span-3 items-start content-start justify-center justify-items-center md:items-center md:content-center gap-4 px-2 grid md:min-h-screen py-4"
      :class="$route.name === 'Verify Otp' ? 'bg-white md:bg-login ' : 'bg-login '"
    >
      <div
        class="flex items-center gap-16 justify-around py-4 md:hidden w-full"
        :class="{ 'flex-row-reverse gap-16': isOkCredit }"
      >
        <img
          src="../assets/logo-primary.png"
          alt="ePaylater Logo"
          width="160"
          height="auto"
          class="w-28 md:w-40"
        />
        <img
          :src="imageUrl"
          alt="Marketplace Logo"
          v-if="imageUrl"
          width="160"
          height="auto"
          class="w-28 md:w-40"
        />
      </div>
      <img
        src="../assets/login-illustration.png"
        alt="Login Illustration"
        :class="$route.name === 'Verify Otp' ? 'hidden md:block' : 'block'"
        class="h-52 w-auto"
      />
      <div
        class="md:py-8 md:px-7 text-center gap-3 justify-center justify-items-center"
        :class="$route.name === 'Verify Otp' ? 'hidden md:grid' : 'grid'"
      >
        <h2 class="text-xl font-bold">Instant Business Credit</h2>
        <p class="text-sm">
          Get up to 25 lakhs credit limit
          <template v-if="!isColgate && !isOkCredit">at 0% interest*</template>
        </p>
        <p class="text-sm">Instant approval and quick activation</p>
        <p class="text-sm">Simple & paperless documentation</p>
        <!-- <p
          v-if="isWalmart"
          class="text-lg font-bold bg-bannerGreen text-white px-4 py-2 flex gap-2 items-center rounded mt-4"
        >
          <img src="../assets/offer-icon.svg" alt="Offer Icon" width="30" height="30" />
          Upto ₹{{ isWalmart ? 250 : 500 }} cashback on limit activation
        </p> -->
      </div>
    </div>
    <div class="col-span-2 md:grid" ref="form">
      <div class="p-8 grid justify-items-center items-start content-center md:gap-8 gap-4">
        <div
          class="md:flex items-center justify-around gap-16 hidden"
          :class="{ 'flex-row-reverse ': isOkCredit }"
        >
          <img
            src="../assets/logo-primary.svg"
            alt="ePaylater Logo"
            width="160"
            height="auto"
            class="w-28 md:w-40"
          />
          <img
            :src="imageUrl"
            alt="Marketplace Logo"
            v-if="imageUrl"
            width="160"
            height="auto"
            class="w-28 md:w-40"
          />
        </div>

        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Login',
  components: {
  },
  computed: {
    ...mapGetters([
      'sessionId',
      'imageUrl',
      'isWalmart',
      'isColgate',
      'isOkCredit',
    ]),
  },
  watch: {
    sessionId() {
      if (this.sessionId) {
        this.$store.dispatch('marketplaceLogoUrl', {
          queryParams: { sessionId: this.sessionId },
        });
      }
    },
  },
  created() {
    // Delete marketplaceInfo from localStorage
    if (localStorage.getItem('marketplaceInfo')) {
      localStorage.removeItem('marketplaceInfo');
    }
  },
  mounted() {
    const { supportId } = this.$route.query;
    if (supportId) {
      this.$store.commit('SET_SUPPORT_ID', supportId);
    }
  },
  methods: {
    showForm() {
      this.$refs.form.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest',
      });
    },
  },
};
</script>
